import React from 'react';
import LayoutProvider from 'context/layout-provider';

import LatestPost from '../../data/latest-post.json';

import Header from './header';
import Footer from './footer';

export default function Layout({ children, path, ...props }) {
  const { post_fields } = LatestPost;
  return (
    <LayoutProvider>
      <Header {...props.location} />
      {children}
      <Footer article={post_fields} />
    </LayoutProvider>
  );
}
